import React from "react";
import CreateMessage from "../pages/groupCockpit/message/Createmessage";
import MessagingEmail from "../pages/groupCockpit/message/MessagingEmail";
import GroupCockpitProfile from "../pages/groupCockpit/GroupCockpitProfile";
import SchoolSetUp from "../pages/groupCockpit/schoolSetUp/Schoolsetup";
import ChangePassword from "../pages/groupCockpit/ChangePassword";
import UserDashboardResolver from "./UserDashboardResolver";
import CalendarList from "../pages/schoolCockpit/events/CalendarList";

// Admission Pages
const AdmissionApplications = () => (
  <div>
    <h2>Admission Applications</h2>
  </div>
);

// Export routes as configuration array
export const groupCockpitRoutes = [
  // Dashboard
  { path: "dashboard", element: <UserDashboardResolver /> },

  // { path: "dashboard", element: <GroupCockpitDashboard /> },

  // SchoolSetUp
  { path: "school-setup", element: <SchoolSetUp /> },
  { path: "school-setup/:id", element: <SchoolSetUp /> },

  // Profile
  { path: "profile", element: <GroupCockpitProfile /> },
  { path: "change-password", element: <ChangePassword /> },

  // Admission Routes
  { path: "admission/applications", element: <AdmissionApplications /> },

  // Messaging Routes
  {
    path: "messaging/create",
    element: <CreateMessage />,
  },
  { path: "messaging/email", element: <MessagingEmail /> },

  // Events Routes
  { path: "calenderList", element: <CalendarList /> },
];

export default groupCockpitRoutes;
